import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'hbo-progress-modal',
  templateUrl: './progress-modal.component.html',
  styleUrls: ['./progress-modal.component.scss']
})
export class ProgressModalComponent implements OnChanges {

  @Input() id?: string | number;
  @Output() confirm = new EventEmitter();


  @Input() head?: string;
  @Input() head5?: string;
  @Input() message?: string;
  @Input() extendedMessage?: string;
  @Input() cancelText?: string;

  @Input() total?: number;
  @Input() createdNumber?: number;
  @Input() modifyingPackage?: boolean;
  @Input() endModify?: number | null;
  @Input() createdPackageId?: number | null;
  @Input() error?: boolean;
  @Input() innerHTMLStyle?: string;

  constructor(
    public router: Router
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.endModify ? close() : null;
    this.error ? (
      // Keep whatever reason the caller passed; the generic key is only the fallback
      this.extendedMessage = this.extendedMessage || 'LICENSE.ERRORCREATINGPACKAGE',
      this.innerHTMLStyle = 'errorMessage text-danger'
    )
    :null;
  }

  goList = () => {
    this.router.navigate(['/licenses/packages']);
    if (this.endModify || (this.total === 1 && this.createdPackageId)) this.router.navigate(['/licenses/packages/edit/' + (this.endModify || this.createdPackageId)])
    else this.router.navigate(['/licenses/packages']);
  }


}
